export default __webpack_public_path__ + "locales/sl/PreparationPortal.json?hash=62d49b15c504fdf706c63ffca21a86a7";